import { render, staticRenderFns } from "./CrmRelativeTable.vue?vue&type=template&id=5b7cbb6c&scoped=true&"
import script from "./CrmRelativeTable.vue?vue&type=script&lang=js&"
export * from "./CrmRelativeTable.vue?vue&type=script&lang=js&"
import style0 from "./CrmRelativeTable.vue?vue&type=style&index=0&id=5b7cbb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cbb6c",
  null
  
)

component.options.__file = "CrmRelativeTable.vue"
export default component.exports